import { string, object, number } from 'yup';

export const schema = object().shape({
  indications: string().required('requiredField'),
  declared_value: number().typeError('onlyNumbers'),
  reference: string().required('requiredField'),
  collected_value: number().typeError('onlyNumbers'),
  money_to_pay_for_package: number().typeError('onlyNumbers'),
  origin_contact: object().shape({
    name: string().nullable().notRequired(),
    phone: string().nullable().notRequired().matches(/^[\d ]*$/, 'onlyNumbers'),
  }),
  customer: object().shape({
    email: string().email('invalidEmailAddress'),
    phone: string().nullable().notRequired().matches(/^[\d ]*$/, 'onlyNumbers')
  }),
});